import LicenseLimitedModal, {
  LicenseLimitedModalPropsBase,
} from "@/components/modal/license-limited-modals/license-limited-modal";
import React from "react";
import { textToMusicLicenseManager } from "@/services/license/license-managers/text-to-music-license-manager";

const TextToSpeechCountLimitedModal = ({
  licenseName,
}: LicenseLimitedModalPropsBase) => {
  const count =
    textToMusicLicenseManager.serviceUsingCountLimiter.getPlanLimit(
      licenseName,
    );

  return (
    <LicenseLimitedModal
      licenseName={licenseName}
      upgradeToMessage={"generate unlimited number of AI text to speech audios"}
      allowsMessage={`${licenseName} version allows you to generate only ${count} text to speech${count > 1 ? "'es" : ""} per day.`}
      shouldNavigateToPricing={true}
    />
  );
};

export default TextToSpeechCountLimitedModal;
